<template>
  <div class="ws-state-tags">
    <form @submit.prevent="$_onTagAdd()">
      <WsState
        :placeholder="placeholder"
        v-model="addingText"
      ></WsState>
    </form>
    <div class="ws-state-tags__tags">
      <a
        class="ws-state-tags__tag"
        v-for="(tag, tagIndex) in value"
        :key="tagIndex"
      >
        <div class="ws-state-tags__tag__text">{{tag}}</div>
        <WsIcon @click="$_onRemove(tagIndex)">cancel</WsIcon>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    addingText: null,
  }),
  methods: {
    $_onTagAdd() {
      const _value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
      const addingItems = this.addingText.split(" ");
      addingItems.forEach((addingItem) => {
        if (_value.includes(addingItem)) {
          return;
        } else {
          _value.push(addingItem);
        }
      });
      this.addingText = null;
      this.$emit("input", _value);
    },
    $_onRemove(index) {
      const _value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
      _value.splice(index, 1);
      this.$emit("input", _value);
    },
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "Enter 新增Tag (可用空白區隔)",
    },
  },
};
</script>

<style>
</style>